export const TX_SEARCH_START = 'TX_SEARCH_START'
export const TX_SEARCH_RESET = 'TX_SEARCH_RESET'
export const TX_SEARCH_INVALID_TERM_SHOW = 'TX_SEARCH_INVALID_TERM_SHOW'
export const TX_SEARCH_INVALID_TERM_HIDE = 'TX_SEARCH_INVALID_TERM_HIDE'

const startSearch = (searchTerm, searchParameter) => ({
  type: TX_SEARCH_START,
  searchTerm,
  searchParameter,
})

const resetSearch = () => ({
  type: TX_SEARCH_RESET,
  searchTerm: '',
  searchParameter: 'client_guid',
})

const invalidTermShow = (error) => ({
  type: TX_SEARCH_INVALID_TERM_SHOW,
  error,
})

const invalidTermHide = () => ({
  type: TX_SEARCH_INVALID_TERM_HIDE,
})

export const doTxSearch = (searchTerm, searchParameter) => (dispatch) =>
  dispatch(startSearch(searchTerm, searchParameter))

export const resetTxSearch = () => (dispatch) => dispatch(resetSearch())

export const termValidationErrorShow = (error) => (dispatch) => dispatch(invalidTermShow(error))

export const termValidationErrorHide = (error) => (dispatch) => dispatch(invalidTermHide(error))
